module.exports = __webpack_public_path__ + "media/images/MR_edit-2d8776e1.svg";